import { gql } from 'graphql-request';

export const NOTE_FIELDS = gql`
  fragment NoteFields on NoteDto {
    noteId
    name
    description
    userId
    taskId
    projectId
    organizationId
    createdAt
    deletedAt
    documents {
      documentId
      name
      url
    }
  }
`;

export const createNote = gql`
  mutation createNote($note: NoteCreateInput!) {
    createNote(note: $note) {
      ...NoteFields
    }
  }
  ${NOTE_FIELDS}
`;

export const getNotesByProject = gql`
  query getNotesByProject($projectId: String!) {
    getNotesByProject(projectId: $projectId) {
      ...NoteFields
    }
  }
  ${NOTE_FIELDS}
`;

export const getNotesByTask = gql`
  query getNotesByTask($taskId: String!) {
    getNotesByTask(taskId: $taskId) {
      ...NoteFields
    }
  }
  ${NOTE_FIELDS}
`;

const NotesGraphQL = {
  queries: {
    getNotesByProject,
    getNotesByTask,
  },
  mutations: {
    createNote,
  },
};

export default NotesGraphQL;
